import React from 'react';
import { X } from 'react-feather';
import { translate } from '../../../translations';
import { Tooltip } from '../../Tooltip/Tooltip';
import { emailValidation } from '../../../utils/FormValidation/FormValidation';
import {
    EMAIL,
    INVALID,
} from '../../../constants/constants';
import './Tag.css';

export class Tag extends React.PureComponent {
    renderClosingButton = () => {
        const {
            onRemoveTagClicked,
            tagId,
            tagType,
            disabled,
        } = this.props;

        const closingButtonClasses = [
            'removeTag',
            disabled && 'disabled',
        ].filter(Boolean).join(' ').trim();

        return (
            <X
                className={closingButtonClasses}
                role="button"
                tabIndex={0}
                onClick={() => !disabled && onRemoveTagClicked(tagId, tagType)}
            />
        );
    };

    renderTags = () => {
        const {
            value,
            tagType,
        } = this.props;

        return (
            <>
                {tagType === 'email' && !emailValidation(value)
                    ? (
                        <Tooltip
                            id="tagErrorTooltip"
                            content={translate('invalid_email')}
                            placement="top"
                            delay={200}
                            trigger={['hover', 'focus']}
                        >
                            {this.renderClosingButton()}
                        </Tooltip>
                    ) : this.renderClosingButton()}
            </>
        );
    };

    render() {
        const {
            value,
            tagType,
            disabled,
        } = this.props;

        const tagWrapperClasses = [
            'tagWrapper',
            tagType === EMAIL && !emailValidation(value) ? INVALID : '',
            disabled && 'disabled',
        ].filter(Boolean).join(' ').trim();
        return (
            <div className={tagWrapperClasses}>
                <span className="tagValue">
                    {value}
                </span>
                {this.renderTags()}
            </div>
        );
    }
}

export default Tag;
